import { LANGS } from "@/i18n";

// SEO-friendly, per-language slugs of the public site.
export const SLUGS = {
  it: { privacy: "privacy", terms: "termini", cookies: "cookie" },
  es: { privacy: "privacidad", terms: "terminos", cookies: "cookies" },
  en: { privacy: "privacy", terms: "terms", cookies: "cookies" },
};

// Standalone static build (frontend/site) sets REACT_APP_SITE_STANDALONE / REACT_APP_SITE_BASE; inside the app both are empty.
export const STANDALONE = process.env.REACT_APP_SITE_STANDALONE === "true";
export const BASE = (process.env.REACT_APP_SITE_BASE || "").replace(/\/$/, "");
export const LEGAL_APPROVED = process.env.REACT_APP_SITE_LEGAL_APPROVED === "true";
export const pathFor = (lang, page = "home") => (page === "home" ? `/${lang}` : `/${lang}/${SLUGS[lang][page]}`);
export const hrefFor = (lang, page) => `${BASE}${pathFor(lang, page)}`;
export const asset = (p) => `${BASE}${p}`;
export const pageFromSlug = (lang, slug) => Object.keys(SLUGS[lang]).find((k) => SLUGS[lang][k] === slug);
export const SITE_URL = (process.env.REACT_APP_SITE_URL || "").replace(/\/$/, "");
export const APP_URL = (process.env.REACT_APP_APP_URL || "").replace(/\/$/, "");
// Standalone site without a configured app URL hides every login link.
export const LOGIN_URL = STANDALONE && !APP_URL ? null : `${APP_URL}/sign-in`;
export const CONTACT_MAIL = "mailto:support@musora.io";
export const INDEXABLE = process.env.REACT_APP_SITE_INDEXABLE === "true";
export const isLang = (l) => LANGS.includes(l);

// Privacy rights form lives in the app (not in the static site): only linked when reachable (same origin in preview, APP_URL in a standalone build).
export const PRIVACY_REQUEST_URL = APP_URL ? `${APP_URL}/richiesta-privacy` : STANDALONE ? "" : "/richiesta-privacy";
